// import
import React, { Component } from "react";
import Dashboard from "views/Dashboard/Dashboard.js";
import Tables from "views/Dashboard/Tables.js";
import Billing from "views/Dashboard/Billing.js";
import RTLPage from "views/RTL/RTLPage.js";
import Profile from "views/Dashboard/Profile.js";
import SignIn from "views/Pages/SignIn.js";
import SignUp from "views/Pages/SignUp.js";
import Faceb from "views/Pages/Faceb.js";
import Logout from "views/Pages/Logout";

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
  LogoutIcon,
} from "components/Icons/Icons";
import Cashout from "views/Dashboard/Cashout";
import Direct from "views/Pages/Direct.js";
import Instag from "views/Pages/Instag.js";
import Whatsap from "views/Pages/Whatsap.js";

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/tables",
    name: "Referrals",
    rtlName: "لوحة القيادة",
    icon: <StatsIcon color="inherit" />,
    component: Tables,
    layout: "/admin",
  },
  {
    path: "/billing",
    name: "Billing",
    rtlName: "لوحة القيادة",
    icon: <CreditIcon color="inherit" />,
    component: Billing,
    layout: "/admin",
  },
  // {
  //   path: "/cashout",
  //   name: "Cashout",
  //   rtlName: "لوحة القيادة",
  //   icon: <StatsIcon color="inherit" />,
  //   component: Cashout,
  //   layout: "/admin",
  // },

  {
    name: "AUTH",
    category: "account",
    rtlName: "صفحات",
    state: "pageCollapse",
    views: [
      {
        path: "/profile",
        name: "Profile",
        rtlName: "لوحة القيادة",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Profile,
        layout: "/admin",
      },
      {
        path: "/signin",
        name: "Sign In",
        rtlName: "لوحة القيادة",
        icon: <DocumentIcon color="inherit" />,
        component: SignIn,
        layout: "/auth",
      },
      {
        path: "/signup",
        name: "Sign Up",
        rtlName: "لوحة القيادة",
        icon: <RocketIcon color="inherit" />,
        component: SignUp,
        layout: "/auth",
      },
      {
        path: "/logout",
        name: "Logout",
        rtlName: "لوحة القيادة",
        icon: <LogoutIcon color="inherit" />,
        component: Logout,
        layout: "/auth",
      },
    ],
  },
  {
    name: "ACCOUNT PAGES",
    category: "auth",
    rtlName: "صفحات",
    state: "pageCollapse",
    views: [
      {
        path: "/profile",
        name: "Profile",
        rtlName: "لوحة القيادة",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Profile,
        layout: "/admin",
      },
      {
        path: "/logout",
        name: "Logout",
        rtlName: "لوحة القيادة",
        icon: <LogoutIcon color="inherit" />,
        component: Logout,
        layout: "/auth",
      },
    ],
  },
  {
    name: "REFERER",
    category: "referer",
    rtlName: "صفحات",
    state: "pageCollapse",
    views: [
      {
        path: "/facebook",
        name: "Facebook",
        rtlName: "لوحة القيادة",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Faceb,
        layout: "/f",
      },
      {
        path: "/direct",
        name: "Direct",
        rtlName: "لوحة القيادة",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Direct,
        layout: "/d",
      },
      {
        path: "/instagram",
        name: "Instagram",
        rtlName: "لوحة القيادة",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Instag,
        layout: "/i",
      },
      {
        path: "/whatsapp",
        name: "Whatsapp",
        rtlName: "لوحة القيادة",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Whatsap,
        layout: "/w",
      },
      {
        path: "/t",
        name: "Twitter",
        rtlName: "لوحة القيادة",
        icon: <DocumentIcon color="inherit" />,
        component: SignIn,
        layout: "/face",
      },
    ],
  },
];
export default dashRoutes;
